module.exports = __webpack_public_path__ + "static/unSignupTip-bg.4829e70f.png";